import React from 'react'

interface FormSectionProps {
  children: React.ReactNode
  className?: string
}

const FormSection: React.FC<FormSectionProps> = ({
  children,
  className = 'mb-6',
}) => {
  return <div className={className}>{children}</div>
}

export default FormSection
